import { FormLabel } from '@/components/ui/form'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'

interface Props {
  className?: string
  value: string
  style?: React.CSSProperties
  onChange: (value: string) => void
}

const roles = [
  {
    id: 'damage',
    label: 'Damage',
    image: 'https://data.wowaudit.com/img/Damage.png',
  },
  {
    id: 'heal',
    label: 'Healer',
    image: 'https://data.wowaudit.com/img/Heal.png',
  },
  {
    id: 'tank',
    label: 'Tank',
    image: 'https://data.wowaudit.com/img/Tank.png',
  },
] as const

const RoleSelector = ({ className, value, style, onChange }: Props) => {
  return (
    <div className='space-y-2'>
      <FormLabel className='block'>Main role</FormLabel>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className={cn('flex gap-4 p-3', className)}
        style={style}
      >
        {roles.map((role) => (
          <label
            key={role.id}
            className={cn(
              'relative cursor-pointer rounded-full transition-all duration-200',
              'ring-2',
              value === role.id
                ? 'ring-primary'
                : 'ring-transparent hover:ring-muted-foreground/50 grayscale opacity-60 hover:opacity-80',
            )}
          >
            <RadioGroupItem value={role.id} className='sr-only' />
            <img
              src={role.image}
              alt={role.label}
              className='w-16 h-16 min-w-16 min-h-16 rounded-full'
            />
          </label>
        ))}
      </RadioGroup>
    </div>
  )
}

export default RoleSelector
